import { createSelector, createAction } from "@reduxjs/toolkit";

// Declaring the Selectors
export const getBasketSelector = (state) => {
  return state.basket;
};

export const getCartDetailsSelector = createSelector(
  getBasketSelector,
  (getAddToCart) => getAddToCart.cart
);

export const itemsInCartSelector = createSelector(
  getCartDetailsSelector,
  (cartDetails) =>
    cartDetails.reduce((total, { quantity }) => {
      return total + quantity;
    }, 0) || 0
);

export const getTotalPriceSelector = createSelector(
  getBasketSelector,
  (getAddToCart) => {
    const val = getAddToCart?.cart?.reduce(
      (total, { price, quantity }) =>
        Number((total + Number(price) * Number(quantity)).toFixed(2)),
      0
    );
    return val;
  }
);

// Declaring Action types
export const AddToCart = "ADD_TO_CART";
export const RemoveFromCart = "REMOVE_FROM_CART";
export const AddToItem = "ADD_TO_ITEM";
export const RemoveFromItem = "REMOVE_FROM_ITEM";
export const ResetCart = "RESET_CART";

// Declaring the Actions
export const AddToCartAction = createAction(AddToCart);
export const RemoveFromCartAction = createAction(RemoveFromCart);
export const AddToItemAction = createAction(AddToItem);
export const RemoveFromItemAction = createAction(RemoveFromItem);
export const ResetCartAction = createAction(ResetCart);

// Decalaring the Reducers
const initialState = {
  cart: [],
};

const getProductIndex = (cart, productId) =>
  cart.findIndex(({ id }) => id === productId);

const addToCartReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AddToCart: {
      const productAvailable = getProductIndex(state.cart, payload.id);
      let modifiedCart = [...state.cart];
      if (productAvailable >= 0) {
        modifiedCart = modifiedCart.filter((product) => {
          if (product.id === payload.id) {
            product.quantity = product.quantity + 1;
          }
          return product;
        });
      } else {
        modifiedCart = [...modifiedCart, { ...payload, quantity: 1 }];
      }
      return { ...state, cart: [...modifiedCart] };
    }
    case AddToItem: {
      const modifiedCart = state.cart.filter((product) => {
        if (product.id === payload) {
          product.quantity = product.quantity + 1;
        }
        return product;
      });
      return { ...state, cart: [...modifiedCart] };
    }
    case RemoveFromCart: {
      /* New learning
        Best way to remove the items
        
        const productAvailable = getProductIndex(state.cart, payload.id);
        let updatedCart = [...state.cart];
        updatedCart.splice(productAvailable, 1);
      */
      const updatedCart = state.cart.filter(
        (product) => product.id !== payload
      );
      return { ...state, cart: updatedCart };
    }
    case RemoveFromItem: {
      let modifiedCart = state.cart.filter((product) => {
        if (product.id === payload) {
          if (product.quantity > 1) {
            product.quantity = product.quantity - 1;
          } else {
            return false;
          }
        }
        return product;
      });
      return { ...state, cart: [...modifiedCart] };
    }
    case ResetCart: {
      return { ...initialState };
    }
    default:
      return state;
  }
};

export default addToCartReducer;
